import styled from '@emotion/styled';
import { badgeColors, BadgeType, customerBadges } from 'src/assets/colors';

export const Badge = styled('span', { label: 'Badge' })<{ 
    badgeType?: BadgeType; 
    uppercase?: boolean; 
}>`
    padding: 0.1em 0.7em;
    border-radius: 3px;
    font-size: 0.85em;
    white-space: nowrap;
    display: inline-block;
    text-transform: ${({ uppercase }): string => (uppercase === true ? 'uppercase' : 'none')};
    
    background-color: ${({ badgeType }): string => 
        badgeType === undefined ? badgeColors.gray.bgColor : badgeColors[badgeType].bgColor};
        
    color: ${({ badgeType }): string => 
        badgeType === undefined ? badgeColors.gray.txtColor : badgeColors[badgeType].txtColor};
`;

/**
 * @deprecated: Please use `Badge` component
 */
export const BadgeColored = styled('span', { label: 'BadgeColored' })<{ badgeColor: string }>`
    padding: .1em .7em;
    border-radius: 3px;
    font-size: .85em;
    white-space: nowrap;
    display: inline-block;
    background-color: ${(props):string => {
        switch (props.badgeColor) {
            case 'red':
                return '#f00';
            case 'green':
                return '#008800';
            case 'amber':
                return '#ff8000';
            case 'gray':
            default:
                return '#f2f2f2';
        }
    }};
    color: ${(props):string => {
        switch (props.badgeColor) {
            case 'red':
            case 'green':
            case 'amber':
                return '#ffffff';
            case 'gray':
            default:
                return '#010000';
        }
    }};
`;

/**
 * @deprecated: Please use `Badge` component
 */
export const RiskBadgeColored = styled('span', { label: 'RiskBadgeColored' })<{ badgeColor: string }>`
    padding: 0.1em 0.7em;
    border-radius: 3px;
    font-size: 0.85em;
    white-space: nowrap;
    display: inline-block;
    text-transform: uppercase;
    background-color: ${(props):string => {
        switch (props.badgeColor) {
            case 'dark-green':
                return customerBadges.darkGreen;
            case 'medium-green':
                return customerBadges.mediunGreen;
            case 'light-green':
                return customerBadges.lightGreen;
            case 'light-red':
                return customerBadges.lightRed;
            case 'medium-red':
                return customerBadges.mediumRed;
            case 'dark-red':
                return customerBadges.darkRed;
            default:
                return customerBadges.grey;
        }
    }};
    color: ${(props):string => {
        switch (props.badgeColor) {
            case 'dark-green':
            case 'medium-green':
            case 'medium-red':
            case 'dark-red':
                return '#ffffff';
            case 'light-green':
            case 'light-red':
            default:
                return '#010000';
        }
    }};
`;

export const ClosureCodes = styled('span', { label: 'ClosureCodes' })`
    margin-left: 5px;
`;
